import { Col, Flex, Row } from 'antd';
import PropTypes from 'prop-types';

export const OPERATION_ANALYSIS_FILTER_WIDTH = 288;

export const operationAnalysisPageContainerStylish = ({ antCls }) => ({
  [`& ${antCls}-page-header-compact`]: {
    [`& ${antCls}-page-header-heading-extra`]: {
      flex: '1 0 100%',
      width: '100%',
      [`> ${antCls}-space`]: {
        width: '100%',
        [`> ${antCls}-space-item`]: {
          width: '100%',
        },
      },
    },
  },
});

const filterColumnProps = {
  xs: 24,
  md: { flex: `${OPERATION_ANALYSIS_FILTER_WIDTH}px` },
};

const OperationAnalysisFilterLayout = ({ actions, dateFilter, scopeFilter }) => (
  <Flex flex="1 1 auto" vertical>
    <Row align="middle" gutter={[8, 8]} justify="end">
      {actions ? <Col>{actions}</Col> : null}
      <Col {...filterColumnProps}>{dateFilter}</Col>
      <Col {...filterColumnProps}>{scopeFilter}</Col>
    </Row>
  </Flex>
);

OperationAnalysisFilterLayout.propTypes = {
  actions: PropTypes.node,
  dateFilter: PropTypes.node.isRequired,
  scopeFilter: PropTypes.node.isRequired,
};

export default OperationAnalysisFilterLayout;
